import React, { useEffect, useRef } from "react";
import cwSuiteLogo from "../../../assets/images/cwsuite-logo.png";

// The v4 left menu: every screen the header used to list as a second row of
// buttons, grouped the way staff think about them (selling, floor work, the day).
// Items with no `onClick` are left out, so the same gating as before applies.
const FashionNavDrawer = ({ open, onClose, title, groups, online }) => {
  const closeRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    closeRef.current?.focus();
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      e.stopPropagation();
      onClose();
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [open, onClose]);

  if (!open) return null;
  const run = (item) => {
    onClose();
    item.onClick();
  };

  return (
    <>
      <div className="fp-mscrim" onClick={onClose} aria-hidden="true" />
      <aside className="fp-menu" role="dialog" aria-modal="true" aria-label="Menu">
        <div className="fp-mhd">
          <span className="fp-mark">
            <b title={title.store}>{title.store}</b>
            {title.sub && <small>{title.sub}</small>}
          </span>
          <button ref={closeRef} type="button" className="fp-ib" aria-label="Close menu" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>
        <nav className="fp-mlist" aria-label="Screens">
          {groups.map((group) => {
            const items = group.items.filter((item) => typeof item.onClick === "function");
            if (!items.length) return null;
            return (
              <div key={group.label} className="fp-mgroup">
                <span className="fp-mg">{group.label}</span>
                {items.map((item) => (
                  <button
                    key={item.label}
                    type="button"
                    className={`fp-mi${item.on ? " is-on" : ""}${item.paused ? " is-paused" : ""}`}
                    aria-current={item.on ? "page" : undefined}
                    aria-label={item.label}
                    title={item.paused ? "Needs a connection" : item.hint}
                    onClick={() => run(item)}
                  >
                    <span className="fp-mi-label">{item.label}</span>
                    {item.badge ? (
                      <span className="fp-mb" aria-hidden="true">
                        {item.badge}
                      </span>
                    ) : null}
                  </button>
                ))}
              </div>
            );
          })}
        </nav>
        {online && (
          <button type="button" className={`fp-mft${online.isOnline ? "" : " is-off"}`} onClick={() => run(online)}>
            <span className="fp-mft-dot" aria-hidden="true" />
            {online.text}
          </button>
        )}
        <div className="fp-mbrand">
          <span>Powered by</span>
          <img src={cwSuiteLogo} alt="CW Suite" width="108" height="16" />
        </div>
      </aside>
    </>
  );
};

export default FashionNavDrawer;
